const m = window.require("discourse/helpers/category-link");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;